var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlandetoxMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 191.864,
    height: 40.131,
    viewBox: "0 0 191.864 40.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:#6a841e;}.c{filter:url(#q);}.d{filter:url(#o);}.e{filter:url(#m);}.f{filter:url(#k);}.g{filter:url(#i);}.h{filter:url(#g);}.i{filter:url(#e);}.j{filter:url(#c);}.k{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 4.957,
    width: 30.432,
    height: 35.174,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 15.299,
    y: 4.957,
    width: 29.091,
    height: 35.174,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 26.506,
    y: 4.957,
    width: 34.086,
    height: 35.174,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 45.067,
    y: 4.957,
    width: 32.884,
    height: 35.174,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 72.925,
    y: 0.301,
    width: 36.692,
    height: 39.333,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 95.363,
    y: 0.316,
    width: 33.849,
    height: 39.319,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 113.581,
    y: 0.316,
    width: 34.811,
    height: 39.319,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 131.583,
    y: 0,
    width: 39.965,
    height: 39.951,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 153.735,
    y: 0.301,
    width: 38.129,
    height: 39.333,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "r"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "r"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-515.878 -747.885)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(524.878 758.842)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, -9, -10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M526.991,759.386q0-.543.52-.544h6.569a5.047,5.047,0,0,1,2.151.457,5.409,5.409,0,0,1,1.694,1.22,5.605,5.605,0,0,1,1.5,3.816,5.456,5.456,0,0,1-.388,2.03,5.537,5.537,0,0,1-1.088,1.734,5.345,5.345,0,0,1-1.673,1.214,4.946,4.946,0,0,1-2.131.457h-3.81v5.748q0,.5-.519.5H527.5a.444.444,0,0,1-.507-.5Zm9.055,4.932a2.469,2.469,0,0,0-.185-.933,2.683,2.683,0,0,0-.51-.811,2.561,2.561,0,0,0-.776-.573,2.216,2.216,0,0,0-.985-.221h-3.256v5.077h3.256a2.293,2.293,0,0,0,.973-.209,2.493,2.493,0,0,0,.782-.562,2.624,2.624,0,0,0,.516-.812A2.522,2.522,0,0,0,536.046,764.318Z",
    transform: "translate(-517.99 -747.88)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, -9, -10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M565.356,759.351a.5.5,0,0,1,.53-.509h2.294a.544.544,0,0,1,.363.133.467.467,0,0,1,.155.376v13.5h7.239a.5.5,0,0,1,.359.144.515.515,0,0,1,.15.388V775.5a.531.531,0,0,1-.14.364.47.47,0,0,1-.37.156H565.863a.449.449,0,0,1-.507-.509Z",
    transform: "translate(-541.06 -747.88)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, -9, -10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M593.47,775.588a3.742,3.742,0,0,1,.133-.428c.05-.131.094-.25.133-.359l6.233-15.52a.69.69,0,0,1,.191-.283.571.571,0,0,1,.422-.156h1.862a.505.505,0,0,1,.4.139,1.506,1.506,0,0,1,.179.243l.382.9L609.51,775.4a.7.7,0,0,0,.018.122.782.782,0,0,1,.017.144q0,.347-.509.347h-2.279a.645.645,0,0,1-.393-.1.759.759,0,0,1-.231-.324l-.209-.532-.439-1.11q-.22-.555-.428-1.122h-7.135q-.3.81-.584,1.521t-.48,1.243a.6.6,0,0,1-.6.428h-2.313a.667.667,0,0,1-.352-.081.265.265,0,0,1-.133-.243A.345.345,0,0,1,593.47,775.588Zm8.049-12.339q-.624,1.6-1.243,3.308t-1.243,3.3h4.927Z",
    transform: "translate(-557.95 -747.88)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, -9, -10.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M640,759.362a.538.538,0,0,1,.133-.37.475.475,0,0,1,.376-.15h2.66a.657.657,0,0,1,.306.075.749.749,0,0,1,.26.237q1.978,2.822,3.92,5.6t3.921,5.6V759.281a.517.517,0,0,1,.173-.324.508.508,0,0,1,.335-.116h2.232a.606.606,0,0,1,.4.139.457.457,0,0,1,.167.37v16.191q0,.474-.543.474h-2.51a.6.6,0,0,1-.474-.312q-2.036-2.949-4.054-5.892t-4.042-5.9v11.6a.533.533,0,0,1-.121.382.55.55,0,0,1-.411.127h-2.22a.5.5,0,0,1-.388-.133.519.519,0,0,1-.121-.364Z",
    transform: "translate(-585.94 -747.88)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(597.803 753.885)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, -81.93, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M543.495,838.107a10.6,10.6,0,0,1-.388,2.893A10.327,10.327,0,0,1,542,843.555a10.626,10.626,0,0,1-3.926,3.783,11.129,11.129,0,0,1-2.62,1.041,11.53,11.53,0,0,1-2.914.366h-7.078a.909.909,0,0,1-.459-.115.515.515,0,0,1-.2-.488V828.086a.711.711,0,0,1,.165-.488.627.627,0,0,1,.5-.187h7.078a11.234,11.234,0,0,1,2.907.373,11.012,11.012,0,0,1,2.613,1.062,11.226,11.226,0,0,1,2.218,1.651,10.226,10.226,0,0,1,1.716,2.153,10.818,10.818,0,0,1,1.1,2.57A10.426,10.426,0,0,1,543.495,838.107Zm-13.136-5.542V843.6h1.206c.22,0,.435-.007.646-.022s.421-.031.632-.05a5.766,5.766,0,0,0,2.01-.524,5.572,5.572,0,0,0,1.629-1.148,5.173,5.173,0,0,0,1.091-1.672,5.466,5.466,0,0,0,.395-2.1,5.374,5.374,0,0,0-.452-2.218,5.484,5.484,0,0,0-1.227-1.752,5.543,5.543,0,0,0-1.816-1.148,6.012,6.012,0,0,0-2.218-.409Z",
    transform: "translate(-442.88 -821.11)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "matrix(1, 0, 0, 1, -81.93, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M581.07,828.107a.684.684,0,0,1,.165-.481.6.6,0,0,1,.465-.179h14.243a.634.634,0,0,1,.489.186.709.709,0,0,1,.172.5v3.55a.75.75,0,0,1-.172.465.6.6,0,0,1-.5.222h-9.3v3.56H593.8a.755.755,0,0,1,.452.129.5.5,0,0,1,.179.431v3.1a.6.6,0,0,1-.158.388.569.569,0,0,1-.459.187h-7.192v3.675h9.647a.577.577,0,0,1,.646.658v3.608a.356.356,0,0,1-.115.258q-.057.4-.589.4H581.7a.67.67,0,0,1-.458-.151.59.59,0,0,1-.172-.467Z",
    transform: "translate(-476.71 -821.13)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, -81.93, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M626.754,828.077a.582.582,0,0,1,.194-.458.7.7,0,0,1,.481-.172h15.447a.726.726,0,0,1,.46.157.644.644,0,0,1,.23.472v3.564a.81.81,0,0,1-.18.494.6.6,0,0,1-.51.236h-4.953v15.72a.685.685,0,0,1-.186.467.623.623,0,0,1-.487.208h-4.21a.674.674,0,0,1-.458-.194.623.623,0,0,1-.215-.481v-15.72h-4.939a.669.669,0,0,1-.481-.186.721.721,0,0,1-.194-.544Z",
    transform: "translate(-504.17 -821.13)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -81.93, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M671.9,837.652a10.91,10.91,0,0,1,1.494-5.549,11.111,11.111,0,0,1,1.717-2.232,10.713,10.713,0,0,1,2.219-1.715,11.255,11.255,0,0,1,2.622-1.105,10.994,10.994,0,0,1,5.839,0,11.23,11.23,0,0,1,2.629,1.105,10.9,10.9,0,0,1,3.944,3.948,11.393,11.393,0,0,1,1.106,2.627,11.006,11.006,0,0,1,0,5.843,11.112,11.112,0,0,1-1.106,2.613,10.809,10.809,0,0,1-1.717,2.211,11.231,11.231,0,0,1-2.227,1.716,10.991,10.991,0,0,1-11.09,0,11.126,11.126,0,0,1-3.936-3.926,10.713,10.713,0,0,1-1.106-2.613A10.882,10.882,0,0,1,671.9,837.652Zm5.556-.014a6.094,6.094,0,0,0,.4,2.225,5.49,5.49,0,0,0,1.126,1.8,5.241,5.241,0,0,0,1.713,1.206,5.659,5.659,0,0,0,4.365,0,5.224,5.224,0,0,0,1.721-1.206,5.5,5.5,0,0,0,1.125-1.8,6.346,6.346,0,0,0,0-4.443,5.563,5.563,0,0,0-1.125-1.816,5.35,5.35,0,0,0-7.8,0,5.559,5.559,0,0,0-1.126,1.816A6.112,6.112,0,0,0,677.452,837.638Z",
    transform: "translate(-531.31 -820.66)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -81.93, -6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M727.474,848.371q.115-.215.237-.438a5.282,5.282,0,0,1,.28-.452l6.46-9.647q-1.651-2.484-3.266-4.91t-3.266-4.91a1.414,1.414,0,0,1-.136-.215.648.648,0,0,1-.064-.215.14.14,0,0,1,.165-.108.552.552,0,0,0,.28-.065h5a.922.922,0,0,1,.833.546l3.517,5.283,3.56-5.283a.922.922,0,0,1,.833-.546h4.781q.158,0,.295.007a.692.692,0,0,1,.236.05.139.139,0,0,1,.1.129.621.621,0,0,1-.158.373l-6.6,9.863,6.733,10.049a2.554,2.554,0,0,1,.223.366.527.527,0,0,1,.064.28q0,.216-.258.215h-5.139a.748.748,0,0,1-.445-.144.971.971,0,0,1-.316-.388l-3.9-5.785-3.862,5.785a.978.978,0,0,1-.316.388.747.747,0,0,1-.445.144h-5.154a.325.325,0,0,1-.2-.065.212.212,0,0,1-.086-.179A.281.281,0,0,1,727.474,848.371Z",
    transform: "translate(-564.71 -821.11)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlandetoxMob);
export default __webpack_public_path__ + "static/media/plandetox_mob.93f99e24d1b44c9e646d5a8da96033bf.svg";
export { ForwardRef as ReactComponent };